import { createFileRoute, Link } from '@tanstack/react-router'
import { useTranslation } from '@/lib/i18n'
import { ProvisionalRanking } from '../../../-components/provisional-ranking'

export const Route = createFileRoute(
	'/(private)/bandi/$residenceId/classifica/'
)({
	// The page reads the data of students and logs the access: only opening it runs the read.
	preload: false,
	component: ProvisionalPage,
	staticData: {
		breadcrumb: 'admin-ranking:provisional_view.open'
	}
})

/** The provisional ranking of a residence with an open call, read only, for the general admin who follows the calls. */
function ProvisionalPage() {
	const { t } = useTranslation()
	const { residenceId } = Route.useParams()
	return (
		<main className='mx-auto flex w-full max-w-5xl flex-col gap-6 p-4 md:p-6'>
			<header className='flex flex-col gap-3'>
				<Link
					className='text-muted-foreground text-sm hover:underline'
					to='/bandi'
				>
					{t('admin-ranking:provisional_view.back')}
				</Link>
				<h1 className='font-semibold text-2xl'>
					{t('admin-ranking:provisional_view.open')}
				</h1>
			</header>
			<ProvisionalRanking residenceId={residenceId} />
		</main>
	)
}
